<template>
  <sky-suffix v-bind="$attrs"
              @search-click="search">
    <el-checkbox :indeterminate="isIndeterminate"
                 v-model="checkAll"
                 @change="handleCheckAllChange"
                 :class="{ noCheckClass: isNoCheck }"
                 class="checkAllClass"
                 v-if="isCheckAll">全部</el-checkbox>
    <el-checkbox-group v-model="checkbox"
                       :value="checkbox"
                       @change="handleChange"
                       v-bind="$attrs"
                       :class="{ noCheckClass: isNoCheck }">
      <el-checkbox v-for="(item, index) in list"
                   :label="item[props.value]"
                   :disabled="item.disabled"
                   :key="index"
                   :style="{ width: checkboxItemWidth }"
                   :border="border">{{ item[props.label] }}</el-checkbox>
    </el-checkbox-group>

    <slot name="toolTips"
          slot="toolTips"></slot>
  </sky-suffix>
</template>
<script>
import SkySuffix from '../formComponents/SkySuffix.vue'
import formStore from '@/mixins/formStore.js'
export default {
  name: 'sky-checkbox',
  componentName: 'sky-checkbox',
  mixins: [formStore],
  components: {
    SkySuffix
  },
  props: {
    name: {},
    value: {},
    border: {
      default () {
        return false;
      }
    },
    isNoCheck: {
      default () {
        return false;
      }
    },
    isCheckAll: {
      default () {
        return false;
      }
    },
    options: {
      default () {
        return [];
      }
    },
    checkboxItemWidth: {
      default: undefined,
    },
    props: {
      default () {
        return {
          label: 'label',
          value: 'value'
        }
      }
    }
  },
  created () { },
  watch: {
    value: {
      handler (val) {
        this.checkbox = [].concat(val);
      },
      immediate: true
    },
    options: {
      handler (val) {
        this.list = _.cloneDeep(this.options)
      },
      immediate: true
    }
  },
  data () {
    return {
      selfData: this.value,
      checkbox: this.value,
      list: this.options || [],
      checkAll: false,
      isIndeterminate: true
    }
  },
  methods: {
    search (e) {
      this.$emit("search-click", e);
    },
    handleChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.checkboxAll.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.checkboxAll.length
      this.$emit('input', value)
    },
    handleCheckAllChange (val) {
      this.checkbox = val ? this.checkboxAll : [];
      this.isIndeterminate = false;
    }
  },
  computed: {
    checkboxAll () {
      return _.map(this.options, item => {
        return item[this.props.value]
      })
    }
  },
};
</script>

<style lang="scss">
.noCheckClass {
	.el-checkbox__input {
		display: none;
	}
	.el-checkbox__label {
		padding-left: 0;
	}
	.el-checkbox + .el-checkbox {
		margin-left: 0;
		margin-right: 25px;
	}
}
.checkAllClass {
	height: 41px;
	margin-right: 15px;
	.el-checkbox__label {
		padding-left: 0;
	}
}
</style>
